module.exports = __webpack_public_path__ + "img/method2-new.fa3fb5bc.png";